<p-accordion [activeIndex]="0">
   <p-accordionTab *ngFor="let releaseNote of releaseNoteDeviceList">
      <ng-template pTemplate="header">
         <div class="flex align-items-center w-full"
            [class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
            <div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">{{ getReleaseNoteTitle(releaseNote) }}
            </div>
         </div>
      </ng-template>
      <p-panel>
         <div [innerHTML]="releaseNote.releaseNoteHtml" style="padding: 15px;
         border: 1px solid #e0e0e0;
         border-radius: 4px;
         background-color: #fcfcfc;
         font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
         line-height: 1.6;
         font-size: 1rem; ">
         </div>
      </p-panel>
   </p-accordionTab>
</p-accordion>
<div class="grid mt-3 mb-1 mx-1 flex justify-content-center align-items-center">
   <button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
      class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
   </button>
</div>